import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import { eContentFields } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { RenderHelper } from "../../utils/render-helper";
import { EditOutlined } from "@ant-design/icons";
import { useMount } from "ahooks";
import _ from "lodash";

export const AddRowModal = ({ dataSource, setDataSource, form }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eNewContentFields, setENewContentFields] = useState<any[]>([]);

  const [childrenForm] = Form.useForm()

  const showModal = () => {
    childrenForm.resetFields();

    childrenForm.setFieldValue("unit", form.getFieldValue("eDepartment"))

    setIsModalOpen(true);
  };
  
  const handleOk = async () => {
    // const validate = await childrenForm.validateFields();
    const values = childrenForm.getFieldsValue();

    setDataSource([...dataSource, values]);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    childrenForm.resetFields();
    setIsModalOpen(false);
  };

  useEffect(() => {
    const newFields = _.cloneDeep(eContentFields);
    for (const value of newFields) {
      if (value.field === "unit") {
        //@ts-ignore
        value.disabled = true;
      }
    }
    setENewContentFields(newFields);
  },[]);

  return (
    <>
      <StyledButton bgColor="yellow" onClick={showModal} className="mb-3">
        <div className="pb-1">Thêm mới</div>
      </StyledButton>

      <Modal
        title={<StyledTitle level={4}>NHÂN SỰ ĐĂNG KÝ KHÓA HỌC</StyledTitle>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={childrenForm}>
          <Row gutter={[32, 0]}>
            <RenderHelper fields={eNewContentFields} />
            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export const EditRowModal = ({ dataSource, setDataSource, index }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eNewContentFields, setENewContentFields] = useState<any[]>([]);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    form.setFieldsValue(dataSource[index]);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = [...dataSource];
    newDataSource[index] = values;

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  useMount(() => {
    const newFields = _.cloneDeep(eContentFields);
    for (const value of newFields) {
      if (value.field === "unit") {
        //@ts-ignore
        value.disabled = true;
      }
    }
    setENewContentFields(newFields);
  });

  return (
    <>
      <Button onClick={showModal} className="mb-3">
        <EditOutlined rev="data" />
      </Button>

      <Modal
        title="NHÂN SỰ ĐƯỢC THAY ĐỔI/BỔ SUNG KHÓA HỌC"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <RenderHelper fields={eNewContentFields} />

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
